import React from 'react';
import { CheckCircle2, ShieldCheck, Zap, Download } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const checkoutUrl = 'https://myschoolofbusiness.com/cart/47422073733314:1';
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden bg-primary-bg" data-id="element-56">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-57">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-3xl" data-id="element-58"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-health/5 blur-3xl" data-id="element-59"></div>
      </div>

      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-61">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-62">
            <h1 className="text-[32px] text-text-primary mb-6 font-[500] font-[Montserrat,_sans-serif]" data-id="element-63">
              "Lo que nadie te explicó sobre tu cuerpo después de los 35: No es
              edad, No es dieta, No es estrés. Solo es una transición hormonal
              Natural del cuerpo ."
            </h1>

            <p className="sm:text-xl text-text-primary/80 mb-8 font-[500] text-[18px]" data-id="element-64">
              Descubre el protocolo digital de 21 días diseñado para ayudar a
              mujeres en peri-menopausia (premenopausia) a reducir hinchazón,
              recuperar energía, dormir mejor y volver a sentirse en control de
              su cuerpo
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-65">
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-5 bg-accent hover:bg-accent-dark text-white rounded-2xl font-bold shadow-[0_8px_20px_rgba(212,163,115,0.3)] hover:shadow-[0_10px_25px_rgba(188,108,37,0.4)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 text-[18px]" data-id="element-66">
                SÍ, QUIERO MI COPIA CON DESCUENTO LIMITADO AHORA
              </a>

              <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-text-primary/70 font-medium" data-id="element-67">
                <span className="flex items-center gap-1.5" data-id="element-68">
                  <CheckCircle2 size={16} className="text-health" data-id="element-69" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center gap-1.5" data-id="element-70">
                  <CheckCircle2 size={16} className="text-health" data-id="element-71" /> Un solo
                  pago
                </span>
                <span className="flex items-center gap-1.5" data-id="element-72">
                  <CheckCircle2 size={16} className="text-health" data-id="element-73" /> Sin
                  suscripciones
                </span>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="mt-10 flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-8 border-t border-text-primary/10 pt-6" data-id="element-74">
              <div className="flex flex-col items-center lg:items-start gap-1" data-id="element-75">
                <Download size={24} className="text-accent" data-id="element-76" />
                <span className="text-xs font-bold text-text-primary uppercase tracking-wider" data-id="element-77">
                  Formato Digital
                </span>
              </div>
              <div className="flex flex-col items-center lg:items-start gap-1" data-id="element-78">
                <Zap size={24} className="text-accent" data-id="element-79" />
                <span className="text-xs font-bold text-text-primary uppercase tracking-wider" data-id="element-80">
                  Acceso Inmediato
                </span>
              </div>
              <div className="flex flex-col items-center lg:items-start gap-1" data-id="element-81">
                <ShieldCheck size={24} className="text-accent" data-id="element-82" />
                <span className="text-xs font-bold text-text-primary uppercase tracking-wider" data-id="element-83">
                  Garantía 30 Días
                </span>
              </div>
            </div>
          </motion.div>

          {/* Image Mockup */}
          <motion.div className="flex-1 relative w-full max-w-lg mx-auto lg:max-w-none" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-84">
            <div className="relative z-10 drop-shadow-2xl" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/iQapRN8y9NN55qNaVV42ua/mock-peri-menopausia.png" alt="Peri-Menopausia Rebelde Ebook Mockup" className="w-full h-auto object-contain" data-id="element-86" />
            </div>
            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-accent/20 blur-[80px] rounded-full -z-10" data-id="element-87"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}